<template>
  <div class="header">
    <div v-if="imageUrl" class="logo-container">
      <img class="logo-image" :src="imageUrl" alt="Header Logo">
    </div>
  </div>
</template>

<script>
import tongxinApi from '@/apis/web/tongxin'

export default {
  name: 'TongxinHeader',
  inject: ['clinicIdData'],
  data() {
    return {
      mobileImage: null,
      isLoading: false,
      error: null
    }
  },
  computed: {
    clinicId() {
      return this.clinicIdData.value
    },
    imageUrl() {
      return this.mobileImage
    }
  },
  watch: {
    clinicId: {
      immediate: true,
      handler(newClinicId) {
        if (newClinicId) {
          this.loadHeaderPhoto()
        }
      }
    }
  },
  methods: {
    async loadHeaderPhoto() {
      if (!this.clinicId) {
        console.warn('Header.vue: clinicId is not provided')
        return
      }

      this.isLoading = true
      this.error = null

      try {
        const response = await tongxinApi.getHeaderPhoto(this.clinicId)

        if (response.data?.mobile) {
          this.mobileImage = response.data.mobile
        }
      } catch (error) {
        console.error('Failed to load header photo:', error)
        this.error = error
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  background: linear-gradient(135deg, #207868 0%, #2a9d8f 100%);
  color: white;
  height: 80px;
  padding: 10px;
  text-align: center;
  position: sticky;
  top: 0;
  z-index: 1;
}

.logo-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
}

.logo-image {
  height: 60px;

  @media screen and (min-width: 768px) {
    height: 80px;
  }
}
</style>
